export default "__VITE_ASSET__D8WMa96I__"